import { useState } from 'react';
import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';

import {
	ShareEducationModalProvider,
	useShareEducationModal,
	// eslint-disable-next-line @change/sibling-module-imports
} from 'src/app/shared/hooks/share/actions/shared/shareAction/shareEducationModal';

import { ActionButtonWrapper } from './ActionButtonWrapper';
import { CustomButton } from './CustomButton';
import { MobileShareModal, usePreloadMobileShareModal } from './MobileShareModal';
import { useMobileModalContext } from './shared/useMobileModalContext';

type Props = {
	sticky: boolean;
	visible: boolean;
	hideSocialProof?: boolean;
};

export const MobileShareButtonContainer: React.FC<Props> = ({ sticky, visible, hideSocialProof = false }) => {
	const [isOpen, setIsOpen] = useState(false);

	usePreloadMobileShareModal();

	const openModal = () => {
		setIsOpen(true);
	};

	const context = useMobileModalContext();

	/**
	 * Single modal instance shared across all channel share actions (instagram,
	 * instagramStories, tiktok).  Channel hooks read openEducationModal from context and
	 * swap in their own content at open-time.
	 */
	const [openEducationModal, educationModal] = useShareEducationModal();

	return (
		<>
			<ActionButtonWrapper visible={visible} sticky={sticky} hideSocialProof={hideSocialProof}>
				<CustomButton inverted onClick={openModal} data-qa="mobile-share-button">
					<Translate value="fe.components.petition_share.action" />
				</CustomButton>
			</ActionButtonWrapper>
			<ShareEducationModalProvider value={openEducationModal}>
				<MobileShareModal context={context} isOpen={isOpen} setIsOpen={setIsOpen} />
				{educationModal}
			</ShareEducationModalProvider>
		</>
	);
};
